<template>
  <f7-page>
    <f7-navbar
      v-if="mostrarNavbarFrm"
      sliding
      no-shadow
      :style="appTheme"
    >
      <f7-link
        back
        class="margin-right"
      >
        <img
          alt="iconBack"
          src="@/static/icons/back.svg"
        >
      </f7-link>
    </f7-navbar>

    <div class="div-FrmEditTypeOfPackaging">
      <f7-row class="row-elementosFrm">
        <f7-button
          small
          fill
          class="btn-confeccion"
          @click="openPopupConfections"
        >
          {{ $t('common.assemblies') }}
        </f7-button>
      </f7-row>
      <f7-row class="row-elementosFrm">
        <f7-col width="50">
          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                ref="UCFamiliaArticulo"
                :title="$t('searchEntity.articleFamily.title.family').toUpperCase()"
                :placeholder="$t('searchEntity.articleFamily.placeholder.selectAFamily')"
                :search-text="$t('searchEntity.articleFamily.searchText')"
                :search-cancellation-text="$t('searchEntity.articleFamily.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.articleFamily.searchNotFoundText')"
                :default-value="familiaDelPedidoActual"
                :end-point-for-code-search="GetArticlesFamilies"
                :end-point-for-list="GetArticlesFamilies"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventFamiliaArticulosSelected"
              />
            </f7-col>
          </f7-row>

          <f7-row>
            <f7-col width="100">
              <UCSearchEntityERP
                ref="UCAticulosDeUnaFamilia"
                :title="$t('common.product').toUpperCase()"
                :placeholder="$t('searchEntity.article.placeholder.selectAnArticle')"
                :search-text="$t('searchEntity.article.searchText')"
                :search-cancellation-text="$t('searchEntity.article.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.article.searchNotFoundText')"
                :default-value="tipoDeProductoPedidoActual"
                :end-point-for-code-search="obtenerArticuloFamilia"
                :end-point-for-list="obtenerArticuloFamilia"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :disabled="familiaDelPedidoActual == null"
                @selection="EventArticuloFamiliaSelected"
              />
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col width="100">
              <!-- <UCArticulosTipoPale
                :valor-por-defecto="tipoDePalePedidoActual"
                plantilla="P2"
              /> -->
              <UCSearchEntityERP
                ref="UCTipoDePale"
                :title="$t('common.pallet').toUpperCase()"
                :placeholder="$t('searchEntity.pallet.placeholder.palletType')"
                :search-text="$t('searchEntity.pallet.searchText')"
                :search-cancellation-text="$t('searchEntity.pallet.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.pallet.searchNotFoundText')"
                :default-value="tipoDePalePedidoActual"
                :end-point-for-code-search="obtenerTipoDePale"
                :end-point-for-list="obtenerTipoDePale"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventTipoDePaleSelected"
              />
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col width="50">
          <f7-row>
            <f7-col width="100">
              <!-- <UCArticulosTipoEnvase
                :valor-por-defecto="tipoDeEnvasePedidoActual"
                plantilla="P2"
              /> -->
              <UCSearchEntityERP
                ref="UCEnvases"
                :title="$t('common.package').toUpperCase()"
                :placeholder="$t('common.package')"
                :search-text="$t('searchEntity.container.searchText')"
                :search-cancellation-text="$t('searchEntity.container.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.container.searchNotFoundText')"
                :default-value="tipoDeEnvasePedidoActual"
                :end-point-for-code-search="obtenerEnvases"
                :end-point-for-list="obtenerEnvases"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventEnvaseSelected"
              />
            </f7-col>
          </f7-row>
          <f7-row>
            <f7-col width="100">
              <!-- <UCMarcas
                :valor-por-defecto="marcaDelPedidoActual"
                plantilla="P2"
              /> -->
              <UCSearchEntityERP
                ref="UCMarcas"
                :title="$t('common.brand').toUpperCase()"
                :placeholder="$t('common.brands')"
                :search-text="$t('searchEntity.brand.searchText')"
                :search-cancellation-text="$t('searchEntity.brand.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.brand.searchNotFoundText')"
                :default-value="marcaDelPedidoActual"
                :end-point-for-list="obtenerMarcas"
                :end-point-for-code-search="obtenerMarcas"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventMarcaSelected"
              />
            </f7-col>
          </f7-row>
          <f7-row>
            <!-- Cantidad Envases por Palé -->
            <div
              v-show="showNumeroEnvases"
              class="div-cantidadEnvasesPorPale"
            >
              <span class="span-texto-azulOscuro-14-500">
                {{ $t('common.packagesPerPallet').toUpperCase() }}
              </span>
              <input
                id="number"
                type="number"
                :placeholder="$t('common.quantity')"
                :value="cantidadEnvasesPorPalet"
                accept="number"
                min="1"
                maxlength="4"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                @input="cantidadEnvasesPorPalet = $event.target.value"
              >
            </div>
          </f7-row>
        </f7-col>
      </f7-row>

      <div class="div-elementoSeparador-90 div-separador" />
      <div class="div-opcionesActions">
        <f7-row>
          <f7-col
            width="50"
            class="col-izquierdaActions"
          >
            <a
              class="link link-izquierdaActions-2"
              @click="CancelarEdicion()"
            >
              {{ $t('common.cancel').toUpperCase() }}
            </a>
          </f7-col>
          <f7-col
            width="50"
            class="col-derechaActions"
          >
            <a
              class="link link-derechaActions-2"
              @click="ConfirmarEdicion()"
            >
              {{ $t('common.confirm').toUpperCase() }}
            </a>
          </f7-col>
        </f7-row>
      </div>
    </div>
    <FrmConfectionsForPalletizing
      ref="FrmConfectionsForPalletizing"
      @confection-selected="setConfection"
    />
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { useAppConfigStore } from '@/js/stores/appConfig';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import FrmConfectionsForPalletizing from '@/pages/production/traceability/palletizing/FrmConfectionsForPalletizing.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { sleep } from '@/js/utils/sleep';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';

export default {
  name: 'FrmLineItemEditing',
  components: {
    UCSearchEntityERP,
    FrmConfectionsForPalletizing,
  },
  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    mostrarNavbarFrm: {
      type: Boolean,
      default: true,
    },
    tipoDeElementoEdicion: {
      type: String,
      default: 'PuntoPaletizado',
    },
    elementoProduccion: {
      type: Object, // PuntoPaletizado o SalidaProduccion
      default: null,
    },
    elementosOcultar: {
      type: Array,
      default: () => [],
    },
  },

  emits: [
    'cerrarFrm',
    'tipoEnvasadoActualizado',
  ],

  data() {
    return {
      pedidoPlanificadoActual: null, // Mantiene el pedidoPlanificado que se establece con el ordenPedidoActual.
      elementoProduccionSeleccionado: null, // Puede ser un punto de paletizado o una salida de producción.
      lineaProduccionSeleccionada: null,
      tipoDePalePedidoActual: null, // Mantiene el tipo de Pale del Pedido planificado visible.
      tipoDeProductoPedidoActual: null, // Mantiene el tipo de Producto del Pedido planificado visible.
      tipoDeEnvasePedidoActual: null, // Mantiene el tipo de Producto del Pedido planificado visible.
      marcaDelPedidoActual: null, // Mantiene la marca del pedido planificado visible.
      familiaDelPedidoActual: null, // Mantiene la familia del pedido planificado visible.
      cantidadEnvasesPorPalet: 0,
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'puntoDePaletizadoSeleccionado',
      'lineaDeProduccionSeleccionada',
      'pedidoPlanificadoSeleccionado',
      'edicionPaleSinPedido',
    ]),
    ...mapState(useAppConfigStore, ['userEnviroment']),
    ...mapWritableState(useTraceabilityStore, ['tipoEnvasadoElementoProduccionSeleccionado']),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
    showNumeroEnvases() {
      return this.elementosOcultar.find((e) => e === 'cantidadEnvasesPorPale') == null;
    },
  },

  watch: {
    activo(val) {
      if (val != null && val !== false) {
        this.InicializarFrm();
      }
    },
  },

  methods: {
    InicializarFrm() {
      Log(this, this.InicializarFrm.name);
      this.elementoProduccionSeleccionado = this.elementoProduccion != null ? this.elementoProduccion : this.puntoDePaletizadoSeleccionado;
      this.lineaProduccionSeleccionada = this.lineaDeProduccionSeleccionada;
      this.pedidoPlanificadoActual = null;
      this.pedidoPlanificadoActual = this.pedidoPlanificadoSeleccionado;
      this.familiaDelPedidoActual = this.tipoEnvasadoElementoProduccionSeleccionado.Articulo.Familia;
      sleep(100).then(() => {
        this.EstablecerValoresDelFormulario();
      });
    },

    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
      this.tipoDePalePedidoActual = null;
      this.tipoDeProductoPedidoActual = null;
      this.tipoDeEnvasePedidoActual = null;
      this.marcaDelPedidoActual = null;
      this.cantidadEnvasesPorPalet = 1;
    },

    EstablecerValoresDelFormulario() {
      Log(this, this.EstablecerValoresDelFormulario.name);
      this.tipoDePalePedidoActual = this.tipoEnvasadoElementoProduccionSeleccionado.Pale;
      this.tipoDeProductoPedidoActual = this.tipoEnvasadoElementoProduccionSeleccionado.Articulo;
      this.tipoDeEnvasePedidoActual = this.tipoEnvasadoElementoProduccionSeleccionado.Envase;
      this.marcaDelPedidoActual = this.tipoEnvasadoElementoProduccionSeleccionado.Marca;
      this.cantidadEnvasesPorPalet = this.tipoEnvasadoElementoProduccionSeleccionado.EnvasesPorPale;
    },

    ObtenerValoresDelFrm() {
      Log(this, this.ObtenerValoresDelFrm.name);
      this.tipoEnvasadoElementoProduccionSeleccionado.Pale = this.tipoDePalePedidoActual;
      this.tipoEnvasadoElementoProduccionSeleccionado.Articulo = this.tipoDeProductoPedidoActual;
      this.tipoEnvasadoElementoProduccionSeleccionado.Envase = this.tipoDeEnvasePedidoActual;
      this.tipoEnvasadoElementoProduccionSeleccionado.Marca = this.marcaDelPedidoActual;
      this.tipoEnvasadoElementoProduccionSeleccionado.EnvasesPorPale = this.cantidadEnvasesPorPalet;
    },

    CancelarEdicion() {
      Log(this, this.CancelarEdicion.name);
      this.tipoEnvasadoElementoProduccionSeleccionado = null;
      this.$emit('cerrarFrm');
    },
    EventFamiliaArticulosSelected(obj) {
      Log(this, this.EventFamiliaArticulosSelected.name);

      this.familiaDelPedidoActual = obj;
      // if (this.tipoDeProductoPedidoActual.Familia != null) this.tipoDeProductoPedidoActual.Familia = this.familiaDelPedidoActual;
    },
    EventArticuloFamiliaSelected(obj) {
      Log(this, this.EventArticuloFamiliaSelected.name);
      this.tipoDeProductoPedidoActual = obj;
    },
    /* familia articulos */
    GetArticlesFamilies(codigo) {
      Log(this, this.GetArticlesFamilies.name);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        return ConexionTA.callObtenerFamiliasDeArticulosRecoleccion(0, codigo, this.lineaProduccionSeleccionada.Id_FincaRelacionada);
      }
      return callExecuteSPERP(
        'APPERPAGRO_FamiliasArticuloXIdGrupoEmpresarialXArticulo',
        [
          { NombreParametro: 'filtro', Valor: (codigo !== undefined && codigo !== null ? `q:${codigo}` : 'q:') },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
          { NombreParametro: 'idsArticulo', Valor: '' },
        ],
        'Comun.FamiliaArticuloJSON',
      );
    },
    /* ARTICULOS POR FAMILIA  */
    async obtenerArticuloFamilia(codigo) {
      Log(this, this.obtenerArticuloFamilia.name);
      const result = await callExecuteSPERP(
        'APPERPAGRO_ArticulosXTipoArticulo',
        [
          { NombreParametro: 'filtro', Valor: (codigo !== undefined && codigo !== null ? `q:${codigo}` : 'q:') },
          { NombreParametro: 'tipoArticulo', Valor: 2 },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa.Id },
          { NombreParametro: 'fecha', Valor: new Date() },
          { NombreParametro: 'materiPrimaCheck', Valor: 0 },
        ],
        'Comun.ArticuloJSON',
      );
      // Filtrar los artículos por la familia del pedido actual, si está definida
      if (this.familiaDelPedidoActual != null) {
        result.data = result.data.filter((e) => e.Familia.Id === this.familiaDelPedidoActual.Id);
      }
      return result;
    },
    async EventEnvaseSelected(obj) {
      Log(this, this.EventEnvaseSelected.name);
      if (obj) {
        this.tipoDeEnvasePedidoActual = obj;
        await this.ObtenerDatosComplementariosArticulo(this.tipoDeEnvasePedidoActual.Id);
      }
    },
    /* Envases */
    obtenerEnvases(codigo) {
      Log(this, this.obtenerEnvases.name);
      // return ConexionTA.callObtenerArticulos(0, 1);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        return ConexionTA.callObtenerEnvasesParaRecoleccion(0, codigo);
      }
      return callExecuteSPERP(
        'APPERPAGRO_ArticulosXTipoArticulo',
        [
          { NombreParametro: 'filtro', Valor: (codigo !== undefined && codigo !== null ? `q:${codigo}` : 'q:') },
          { NombreParametro: 'tipoArticulo', Valor: 1 },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa.Id },
          { NombreParametro: 'fecha', Valor: new Date() },
          { NombreParametro: 'materiPrimaCheck', Valor: 0 },
        ],
        'Comun.ArticuloJSON',
      );
    },
    EventTipoDePaleSelected(obj) {
      Log(this, this.EventTipoDePaleSelected.name);
      this.tipoDePalePedidoActual = obj;
    },
    /* Tipo palet */
    obtenerTipoDePale(codigo) {
      Log(this, this.obtenerTipoDePale.name);
      // return ConexionTA.callObtenerArticulos(0, 0);
      if (this.lineaProduccionSeleccionada.Id_FincaRelacionada !== 0) {
        return ConexionTA.callObtenerPaletsParaRecoleccion(0, codigo);
      }
      return callExecuteSPERP(
        'APPERPAGRO_ArticulosXTipoArticulo',
        [
          { NombreParametro: 'filtro', Valor: (codigo !== undefined && codigo !== null ? `q:${codigo}` : 'q:') },
          { NombreParametro: 'tipoArticulo', Valor: 0 },
          { NombreParametro: 'idEmpresa', Valor: this.userEnviroment.EntornoDeTrabajo.Empresa.Id },
          { NombreParametro: 'fecha', Valor: new Date() },
          { NombreParametro: 'materiPrimaCheck', Valor: 0 },
        ],
        'Comun.ArticuloJSON',
      );
    },
    EventMarcaSelected(obj) {
      Log(this, this.EventMarcaSelected.name);
      this.marcaDelPedidoActual = obj;
    },
    /* tmarcas */
    obtenerMarcas(codigo) {
      Log(this, this.obtenerMarcas.name);
      // return callObtenerMarcas({ codigoMarca: value });
      return callExecuteSPERP(
        'APPERPAGRO_MarcasXIdGrupoEmpresarial',
        [
          { NombreParametro: 'filtro', Valor: (codigo !== undefined && codigo !== null ? `q:${codigo}` : 'q:') },
          { NombreParametro: 'idsGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
        ],
        'Comun.MarcaJSON',
      );
    },

    ConfirmarEdicion() {
      Log(this, this.ConfirmarEdicion.name);

      const self = this;
      this.ModificarDatosEnvasadoEnElementoDeProduccion().then(() => {
        // La modificación se realizo correctamente actualizamos los valores
        self.ObtenerValoresDelFrm();
        this.tipoEnvasadoElementoProduccionSeleccionado = self.tipoEnvasadoElementoProduccionSeleccionado;

        self.$emit('tipoEnvasadoActualizado');
        self.$emit('cerrarFrm');
      })
        .catch((error) => {
          LogError(this, this.ConfirmarEdicion.name, error);
          self.$emit('cerrarFrm');
        });
    },

    async openPopupConfections() {
      Log(this, this.openPopupConfections.name);
      const idClient = await this.getClientByOrder();
      this.$refs.FrmConfectionsForPalletizing.open(idClient);
    },
    setConfection(value) {
      Log(this, this.setConfection.name);
      if (value.Producto !== null) {
        this.$refs.UCFamiliaArticulo.SelectEntity(value.Producto.Familia, false);
        this.familiaDelPedidoActual = value.Producto.Familia;
      }
      if (value.Producto !== null) {
        this.$refs.UCAticulosDeUnaFamilia.SelectEntity(value.Producto, false);
        this.tipoDeProductoPedidoActual = value.Producto;
      }
      if (value.Palet !== null) {
        this.$refs.UCTipoDePale.SelectEntity(value.Palet, false);
        this.tipoDePalePedidoActual = value.Palet;
      }
      if (value.Envase !== null) {
        this.$refs.UCEnvases.SelectEntity(value.Envase, false);
        this.tipoDeEnvasePedidoActual = value.Envase;
      }
      if (value.Marca !== null) {
        this.$refs.UCMarcas.SelectEntity(value.Marca, false);
        this.marcaDelPedidoActual = value.Marca;
      }
      this.cantidadEnvasesPorPalet = value.EnvasesPorPalet;
    },

    ModificarDatosEnvasadoEnElementoDeProduccion() {
      Log(this, this.ModificarDatosEnvasadoEnElementoDeProduccion.name);
      const self = this;

      return new Promise((resolve, reject) => {
        ConexionTA.callModificarDatosEnvasadoEnElementoDeProduccion(
          self.elementoProduccionSeleccionado.Id,
          self.tipoDeElementoEdicion,
          self.tipoDePalePedidoActual.Id,
          self.tipoDeEnvasePedidoActual.Id,
          self.tipoDeProductoPedidoActual.Id,
          self.marcaDelPedidoActual != null ? self.marcaDelPedidoActual.Id : 0,
          self.cantidadEnvasesPorPalet,
        ).then((result) => {
          if (result.Valor) {
            resolve();
            HiDialog.Preloader(false);
          } else {
            reject();
            HiNotification.Toast(result.Mensaje);
            HiDialog.Preloader(false);
          }
        })
          .catch((error) => {
            LogError(this, this.ModificarDatosEnvasadoEnElementoDeProduccion.name, error);
            reject();
            HiDialog.Preloader(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          });
      });
    },
    async getClientByOrder() {
      Log(this, this.getClientByOrder.name);
      let client = null;
      if (!this.edicionPaleSinPedido) {
        await callExecuteSPERP(
          'APPERPAgro_LeerClienteXPedidoVenta',
          [{ NombreParametro: '@IdPedido', Valor: this.pedidoPlanificadoActual.IdPedidoVenta }],
          'Comun.ClienteJSON',
        ).then((result) => {
          if (result.status === 200) {
            if (result.data.length > 0) {
              [client] = result.data;
            }
          }
        });
      }
      return client;
    },
    async ObtenerDatosComplementariosArticulo(idArticulo) {
      Log(this, this.ObtenerDatosComplementariosArticulo.name);
      await ConexionTA.callObtenerDatosComplementariosEntidadSeleccionada(idArticulo, 'Articulo', false).then((result) => {
        if (result.Valor) {
          const datosComplementarios = JSON.parse(result.Mensaje);
          datosComplementarios.forEach((element) => {
            if (element.Codigo === 'EXP') {
              if (element.Valor !== '') {
                this.cantidadEnvasesPorPalet = Number.parseInt(element.Valor, 10);
              }
            }
          });
        }
      });
    },
  },

};
</script>

<style scoped lang="scss">
.page {
  background-color: var(--f7-page-bg-color) !important;
}

.div-FrmEditTypeOfPackaging {
  margin-top: 30px;

  .row-elementosFrm {
    .col-50 {
      .row {
        margin-top: 15px;
      }
    }
  }
}

#number {
  width: 100%;
  height: 50px;
  color: var(--his-ash-gray);
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  background-color: #fff;
  padding-left: 17px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
}

.row-elementosFrm {
  margin-left: 10px;
  margin-right: 25px;
  margin-bottom: 5px;
}

.div-opcionesActions {
  width: 94%;
  bottom: 10px;
  position: absolute;
}

.div-separador {
  width: 94%;
  bottom: 45px;
  position: absolute;
}

/* .div-cantidadEnvasesPorPale {
  margin-top: 18px;
} */
</style>
